import instance from './instance';

export const getStatistics = async ({ queryKey }) => {
  try {
    const [, query] = queryKey;
    const response = await instance.get('/v1/dashboard/get_statistics', {
      params: query,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching statistics data:', error);
    throw error;
  }
};

export const getNav = async ({ queryKey }) => {
  try {
    const [, query] = queryKey;
    const response = await instance.get('/v1/dashboard/get_equity', {
      params: query,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching NAV data:', error);
    throw error;
  }
};

export const getDailyPerformance = async ({ queryKey }) => {
  try {
    const [, query] = queryKey;
    const response = await instance.get('/v1/dashboard/get_daily_pnl', {
      params: query,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching daily performance data:', error);
    throw error;
  }
};

export const getCumulativePnl = async ({ queryKey }) => {
  try {
    const [, query] = queryKey;
    const response = await instance.get('/v1/dashboard/get_cumulative_pnl', {
      params: query,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching cumulative PnL data:', error);
    throw error;
  }
};

export const getAccountsGreeks = async ({ queryKey }) => {
  try {
    const [, query] = queryKey;
    const response = await instance.get('/v1/dashboard/get_greeks', {
      params: query,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching accounts greeks data:', error);
    throw error;
  }
};

export const getAccountsGreeksPnl = async ({ queryKey }) => {
  try {
    const [, query] = queryKey;
    const response = await instance.get('/v1/dashboard/get_greeks_pnl', {
      params: query,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching accounts greeks PnL data:', error);
    throw error;
  }
};

export const getMaintenanceMargin = async ({ queryKey }) => {
  try {
    const [, query] = queryKey;
    const response = await instance.get(
      '/v1/dashboard/get_maintenance_margin',
      {
        params: query,
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching maintenance margin data:', error);
    throw error;
  }
};
